<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" :childrenIndex="childrenIndex" />
    <banner :bannerObj="bannerObj" @dialogVisible="getChild" />
    <p class="briefing-content">优化传统系统的数据报表模式，实现数据共享、多维度分析、可视化，支持手机端、PC端、大屏</p>
    <product-content
     style="padding-top:0.218rem;"
      :productContentArr = product
    />
    <footer-a />
    <back-top />
    <dialog-business :dialogVisible="dialogVisible" @dialogVisible="closeFn"/>
  </div>
</template>

<script>
import navTop from '../components/nav'
import banner from '../components/banner'
import productContent from '../components/productContent'
import footerA from '../components/footer'
import backTop from '../components/backTop'
import dialogBusiness from '../components/dialogBusiness'
import i1 from '../assets/images/briefing/1.png'
import i2 from '../assets/images/briefing/2.png'
import i3 from '../assets/images/briefing/3.png'
import i4 from '../assets/images/briefing/4.png'
import i5 from '../assets/images/briefing/5.png'
export default {
  data () {
    return {
      product: [
        {img: i1, content: '实时连接多种应用系统数据源格式，实时数据参数刷新。支持海量数据，秒级响应。简单的拖拽即可对数据进行多维度，多类型分析', label: '直连系统数据', type: 'left', style: 'width: 2.4rem;'},
        {img: i2, content: '可以在任意电脑上使用帐号登录平台，无需要安装，基于机端、大屏端的全平台完美呈现', label: '全平台、跨设备', type: 'right', style: 'width: 2.4rem;'},
        {img: i3, content: 'Banber简报作品可一键快速分享至任意社交网络，作者更新作品后无需重新分享，所有阅读者相关简报自动更新', label: '快速传播分享', type: 'left', style: 'width: 2.4rem;'},
        {img: i4, content: '简单易用的用户体验，零代码建立传输任务，降低用户使用门槛，与客户内部办公平台（如：OA，APP，邮件等) 进行无缝集成，作为客户内部报告制作与发布平台', label: '零代码', type: 'right', style: 'width: 2.4rem;'}
      ],
      bannerObj: {
        img: i5,
        title: '智绘简报',
        content: '数据可视化，人人都可BI',
        button: '业务咨询'
      },
      topIndex: 1,
      childrenIndex: 3,
      dialogVisible: false
    }
  },
  components: {
    navTop,
    banner,
    productContent,
    backTop,
    dialogBusiness,
    footerA
  },
  methods: {
    getChild (v) {
      this.dialogVisible = v
    },
    closeFn (v) {
      this.dialogVisible = v
    }
  }
}
</script>

<style scoped>
.briefing-content{
  font-size:20px;
  font-family:PingFang SC;
  font-weight:500;
  line-height:35px;
  color:rgba(102,102,102,1);
  margin-top: 75px;
}

</style>



// WEBPACK FOOTER //
// src/view/briefing.vue